<template>
  <div class="application-component"
       v-if="formDescriptors.length">
    <!-- Title -->
    <div class="columns">
      <div class="column is-12">
        <title-component
          class="is-uppercase"
          :size="layout.title_size"
          :lineSeparator="layout.title_line_separator">
          {{ title }}
        </title-component>
        <!-- Description -->
        <div class="subtitle is-6">{{ description }}</div>
      </div>
    </div>

    <!-- Forms -->
    <template v-if="formDescriptors && formDatas">
      <form-component
        v-for="formDescriptor in formDescriptors"
        :formDescriptor="formDescriptor"
        :formData="getFormDataForDescriptor(formDescriptor)"
        :key="formDescriptor.id">
      </form-component>
    </template>

    <!-- Buttons -->
    <div class="field is-grouped">
      <p class="control">
        <submit-btn-component class="is-primary is-large is-uppercase" @submit="initSaveApplication" :group="'btnGroup'" v-translate>Send in application</submit-btn-component>
      </p>
      <p class="control">
        <submit-btn-component class="button is-danger is-outlined is-large" @submit="$router.push({ name: 'WelcomeView' })" :group="'btnGroup'" v-translate>
          Cancel
        </submit-btn-component>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import FormComponent from '@/components/form/FormComponent'
  import { formHandlerMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'

  let VueScrollTo = require('vue-scrollto')

  export default {
    name: 'application-component',
    mixins: [formHandlerMixin, setContainedHeightMixin],
    directives: {
      VueScrollTo
    },
    data () {
      return {
        submitRequest: null
      }
    },
    props: {
      code: {
        required: true
      }
    },
    components: {
      FormComponent,
      TitleComponent,
      SubmitBtnComponent
    },
    computed: {
      ...mapState({
        title: state => state.formModule.title,
        description: state => state.formModule.description,
        layout: state => state.formModule.layout,
        formDescriptors: state => state.formModule.formDescriptors,
        formDatas: state => state.formModule.formDatas,
        service: state => state.formModule.service
      })
    },
    methods: {
      ...mapActions([
        'setupApplicationForm',
        'initAssentlyForm',
        'validateAssentlyForm',
        'saveApplicationForm',
        'clearData',
        'successMessage',
        'getAssentlyUrl'
      ]),
      initSaveApplication (btn) {
        let countryFieldId = 'customer_country'
        let assentlyCountryCodes = ['SE']
        this.formDatas.forEach(formData => {
          Object.keys(formData.fields).forEach(key => {
            if (key.indexOf(countryFieldId) !== -1) {
              if (assentlyCountryCodes.includes(formData.fields[key].value)) {
                return this.initAssently(btn)
              }
              return this.saveApplication(btn)
            }
          })
        })
      },
      initAssently (btn) {
        let requestData = {
          formDatas: this.formDatas,
          service: this.service
        }
        this.mixin.callbackData = { btn: btn }
        this.submitRequest = this.initAssentlyForm
        this.submitForm(requestData, btn, this.initAssentlyCallback)
      },
      initAssentlyCallback (response, callbackData) {
        callbackData.btn.disable()
        const token = response.data.token
        // eslint-disable-next-line
        coreid_client.init({
          config: {
            allowedEids: [response.data.provider], // list enabled eID providers
            mode: response.data.mode, // sets the mode to authentication
            language: response.data.language, // set the client to use swedish language
            provider: response.data.provider // default provider to show on start
          },
          token: token,
          callback: (data) => {
            if (data.success === true) {
              // eslint-disable-next-line
              coreid_client.close()
              // Identification has been performed, now validate the token's authenticity
              let validationData = {
                authToken: token,
                identityToken: data.token,
                formDatas: this.formDatas,
                service: this.service
              }
              this.submitRequest = this.validateAssentlyForm
              this.submitForm(validationData, callbackData.btn, this.validateAssentlyCallback)
            } else if (data.type === 'error') {
              console.log('an error occurred', data.errorMessage)
              callbackData.btn && callbackData.btn.enable()
            } else {
              callbackData.btn && callbackData.btn.enable()
            }
          }
        })
        // start the client!
        // eslint-disable-next-line
        coreid_client.start()
      },
      validateAssentlyCallback (response) {
        this.successMessage(this.$ngettext('Application sent'))
        this.$router.push({ name: 'ThankYouView', params: { email: response.data.email, bookedexam: response.data.brage_exam_booked } })
      },
      saveApplication (btn) {
        let requestData = {
          formDatas: this.formDatas,
          service: this.service
        }
        this.submitRequest = this.saveApplicationForm
        this.submitForm(requestData, btn, this.saveApplicationCallback)
      },
      saveApplicationCallback (response) {
        this.successMessage(this.$ngettext('Application sent'))
        this.$router.push({ name: 'ThankYouView', params: { email: response.data.email, bookedexam: response.data.brage_exam_booked } })
      },
      setupForm () {
        this.setupApplicationForm(this.code).then(() => {
          this.setContainedHeight()
        }).catch((err) => {
          this.handleError(err)
        })
      }
    },
    created () {
      this.setupForm()
      this.$root.$on('languageChanged', this.setupForm)
    },
    mounted () {
      this.getAssentlyUrl().then((response) => {
        let assentlyScript = document.createElement('script')
        // We want to be able to later remove the script
        assentlyScript.setAttribute('id', 'assentlyScript')
        assentlyScript.setAttribute('src', response.data.result)
        document.head.appendChild(assentlyScript)
      })
      // cache busting at it's finest
      // eslint-disable-next-line
      if (typeof coreid_client !== 'undefined') {
        location.reload()
      }
    },
    beforeDestroy () {
      // Remove assently script before moving over to a new page
      let assentlyScript = document.getElementById('assentlyScript')
      document.head.removeChild(assentlyScript)
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
</style>
